import React from 'react';
import { components, MenuListProps } from 'react-select';

import { AvatarOption } from '../avatar-select/avatar-select-option';

type CustomMenuListProps = MenuListProps<AvatarOption>;

export const CustomMenuList: React.FC<CustomMenuListProps> = ({ children, ...props }) => {
  //   @ts-ignore
  const { setHasOptions } = props.selectProps;

  if (children && React.Children.count(children)) {
    // Defer out of render — calling setHasOptions (which updates the parent
    // MemberRoleSelector) during react-select's render triggers React's
    // "Cannot update a component while rendering a different component" error
    // and the resulting render churn.
    queueMicrotask(() => setHasOptions(true));
  }

  return <components.MenuList {...props}>{children}</components.MenuList>;
};
